import { ModelRoutes, ModelApiService } from "services/strapi"
import { IDocumentFolder } from "features/document-folders"

class DocumentFolderApiSingleton extends ModelApiService<IDocumentFolder> {}

export const documentFolderApi = new DocumentFolderApiSingleton(
  ModelRoutes.DocumentFolders
)
